import DSSSideEffectsAndAllergies from 'dashboard/templates/views/DSS/DSSSideEffectsAndAllergies';

export default {
  path: 'side-effects-and-allergies',
  name: 'DSSSideEffectsAndAllergies',
  component: DSSSideEffectsAndAllergies,
  meta: {
    // title: 'MDSS - Side Effects and Allergies',
    title: t => `MDSS - ${t('medicationRejectionOfGuideline.allergies')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
